export function objectToFormData(object: Record<string, any>, form = new FormData(), namespace = ""): FormData {
  Object.entries(object).forEach(([key, value]) => {
    const formKey = namespace ? `${namespace}[${key}]` : key;

    if (value instanceof File) {
      form.append(formKey, value, value.name);
    } else if (typeof value === "object" && value !== null) {
      objectToFormData(value, form, formKey);
    } else {
      form.append(formKey, String(value));
    }
  });

  return form;
}
